import React from 'react';
import CommonPage from '../../components/CommonPage';
const pageType = "CLIENT";

function ClientApp(props) {
    return <CommonPage pageType={pageType} />;
}

export default ClientApp;